import { Fragment, useEffect, useState } from "react";
import ViewHeader from "../SubComponents/ViewHeader";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import ResCard from "../SubComponents/ResCard";
import { useParams } from "react-router-dom";
import PodcastPlayer from "./PodcastPlayer";
import MHSubscribe from "../../Layout/MHSubscribe";
import MHFooter from "../../Layout/MHFooter";
import Slider from "react-slick";
import { ResourcesData } from "../../NewLanding/EventGlance";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { db } from "../../../firebase";
import AnimatedLoaderText from "../../Common/Loading/AnimatedLoaderText";
import dayjs from "dayjs";

const ViewPodcast = () => {
  const [podcast, setPodcast] = useState<ResourcesData | null>(null);
  const [podcastData, setPodcastData] = useState<ResourcesData[]>([]);

  const slice = podcastData.slice(0, 3);

  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    const getPodcast = async () => {
      try {
        const collectionRef = collection(db, "caf-podcast-list");
        const querySnapshot = await getDocs(
          query(collectionRef, where("slug", "==", slug)),
        );

        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          setPodcast(doc.data() as ResourcesData);
        }
      } catch (error) {
        console.error("Error fetching podcast:", error);
      }
    };

    if (slug) getPodcast();
  }, [slug]);

  useEffect(() => {
    const getResources = async () => {
      try {
        const collectionRef = collection(db, "caf-podcast-list");
        const querySnapshot = await getDocs(
          query(collectionRef, orderBy("slug", "asc")),
        );

        const data = querySnapshot.docs.map((doc) => ({
          ...(doc.data() as ResourcesData),
        }));

        setPodcastData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getResources();
  }, []);

  const settings = {
    centerMode: true,
    centerPadding: "22px",
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 800,
    autoplay: false,
  };

  if (!podcast)
    return <AnimatedLoaderText text="Fetching data, please wait..." />;

  return (
    <Fragment>
      <ViewHeader
        titles={podcast.title}
        headerClassName="bg-lilac-300 w-full h-[530px] md:h-full px-4 md:px-0 md:pt-2 lg:pt-6 pt-6 md:pl-12 lg:pl-20 relative"
        description={podcast.caption}
        headerDateClass="text-center block md:hidden mt-12 text-[12px] uppercase font-areaExt"
        imageUrl={
          podcast.imgSrc ||
          "https://mh-resources-production.s3.us-west-1.amazonaws.com/caf_podcast.jpg"
        }
        imageClass="overflow-hidden h-full w-full object-cover"
        categoryClassName="lg:-bottom-14 lg:absolute md:relative md:-bottom-14 mb-14 md:w-2/3"
        category={[]}
        episodeLength={podcast?.length ?? ""}
        downloadLink="https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkLnBvZGJlYW4uY29tL21vdGhlcmhvbmVzdGx5L2ZlZWQueG1s"
        downloadClassName="flex -ml-4 my-8 hidden"
        SocialClassName="block"
        TabSocialClass="absolute gap-4 bottom-[35px] text-center place-content-center hidden md:flex lg:hidden md:right-4"
        date={podcast?.releaseDate ?? ""}
        ticketClassName="py-6 hidden"
        podClassName="lg:flex grid gap-4 md:gap-4 my-6 w-2/3 lg:w-fit mx-auto md:mx-0"
        dateClassName="hidden text-left pb-2 w-3/4 text-base font-areaSemi"
        episodeClassName="text-center md:text-left pb-8 md:w-3/4 text-xl md:text-[22px] font-areaSemi"
        episode={podcast?.episodeNo ?? 0}
        season={podcast?.seasonNo ?? 0}
        spotifyUrl={podcast.url}
        youtubeUrl={podcast.videoLink}
        authorClassName="hidden"
      />

      <Box className="mx-auto pt-10 bg-white px-6 md:px-20 lg:px-[170px] py-4">
        <Typography
          variant="h1"
          color="primary"
          className="font-areaSemi text-xl text-center py-4"
        >
          Listen Now
        </Typography>

        <PodcastPlayer spotifyUrl={podcast.url} />
      </Box>

      <Box className="px-4 w-full md:px-20 lg:px-64 pb-6 bg-white">
        <Box className="flex">
          <div dangerouslySetInnerHTML={{ __html: podcast.description }} />
        </Box>
      </Box>

      <Box className="bg-gray-300 h-[1px] w-[91.4%] opacity-50 overflow-hidden mx-auto"></Box>

      {/* For Web */}
      <Box className="mx-auto pt-10 bg-white hidden md:block px-20 py-12">
        <Typography
          variant="h1"
          color="primary"
          className="font-areaSemi text-xl text-center py-4"
        >
          Episodes You Might Like
        </Typography>
        <Grid
          container
          spacing={2}
          className=" place-content-center place-items-center"
        >
          {slice.map((res, index) => (
            <Grid item xs={12} sm={6} md={3} lg={3} key={res.slug ?? index}>
              <ResCard
                cardClass="relative mb-10 w-[305px] h-[430px] object-cover bg-cream-100 rounded-md"
                iconClass="hidden"
                imgBg="bg-green-100 h-[280px]"
                bodyBg="bg-cream-100"
                imageSrc={
                  res.imgSrc ||
                  "https://mh-resources-production.s3.us-west-1.amazonaws.com/caf_podcast.jpg"
                }
                season={res.seasonNo}
                episode={res.episodeNo}
                title={res.title}
                length={res.length}
                titleUrl={`/podcasts/${res.slug}`}
                playUrl={`/podcasts/${res.slug}`}
                releaseDate={dayjs(res.releaseDate).format("MMMM D")}
              />
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* For Mobile */}
      <Box className="mx-auto pt-10 md:hidden block bg-white px-4 py-4 overflow-x-hidden">
        <Typography
          variant="h1"
          color="primary"
          className="font-areaSemi text-xl text-center py-12"
        >
          Episodes You Might Like
        </Typography>
        <Slider {...settings}>
          {slice.map((res, index) => (
            <Grid item xs={12} md={6} lg={3} key={index}>
              <ResCard
                cardClass="relative mb-10 w-[305px] h-[430px] object-cover bg-cream-100 rounded-md"
                iconClass="hidden"
                imgBg="bg-green-100 h-[280px]"
                bodyBg="bg-cream-100"
                imageSrc={
                  res.imgSrc ||
                  "https://mh-resources-production.s3.us-west-1.amazonaws.com/caf_podcast.jpg"
                }
                title={res.title}
                titleUrl={`/podcasts/${res.slug}`}
                playUrl={`/podcasts/${res.slug}`}
                releaseDate={dayjs(res.releaseDate).format("MMMM D")}
                season={res.seasonNo}
                episode={res.episodeNo}
                length={res.length}
              />
            </Grid>
          ))}
        </Slider>
      </Box>

      <MHSubscribe />
      <MHFooter />
    </Fragment>
  );
};

export default ViewPodcast;
